import type {
  BusinessClaimsVendorGroup,
  BusinessClaimsVendorRowState,
  VendorBusinessClaimApplyRow,
} from '../types/business-claims.types';
import { parseBusinessUsePercentInput } from '../utils/transaction-tax-utils';

export function vendorRowStatesFromGroups(
  groups: BusinessClaimsVendorGroup[]
): BusinessClaimsVendorRowState[] {
  return groups.map((group) => ({
    group,
    selected: true,
    businessUsePercentInput:
      group.businessUsePercent != null ? String(group.businessUsePercent) : '100',
  }));
}

export function buildVendorApplyRows(
  rows: BusinessClaimsVendorRowState[]
): VendorBusinessClaimApplyRow[] {
  return rows
    .filter((r) => r.selected)
    .map((row) => ({
      transactionIds: row.group.transactionIds,
      businessUsePercent: parseBusinessUsePercentInput(row.businessUsePercentInput),
    }))
    .filter((row): row is VendorBusinessClaimApplyRow => row.businessUsePercent !== null);
}
